import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* withdrawUnmaskingInvitation({ payload: { id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.unmasking.invitations.withdraw, id });

    onSuccess && onSuccess();
    yield put(actions.withdrawUnmaskingInvitationDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.withdrawUnmaskingInvitationFailed,
      endpoint: api.unmasking.invitations.withdraw.url
    });
  }
}

export const withdrawUnmaskingInvitationSaga = takeEvery(types.WITHDRAW_UNMASKING_INVITATION_REQUEST, withdrawUnmaskingInvitation);